module.exports = __webpack_public_path__ + "media/images/pc/stores/karuizawa/karuizawa_concept_01-061814dc68099e027c9226d20fc8d6ee.jpg";